import { Component, h } from 'preact';
import { html } from '../../helpers/preact-html';

class DesktopNavigationFooter extends Component {
  constructor() {
    super();
  }

  render({ navTree: { footer } }) {
    return html`
      <div class="navigation-footer">
        ${footer.button &&
        html`
          <a href=${footer.button.href} class="button button-large spacer-s"
            >${footer.button.label}</a
          >
        `}
        <div class="label">Service</div>
        ${footer.links.map(
          ({ label, iconClass, href }, index) => html`
            <a class="navigation-linkicon" href=${href} key=${index}>
              ${iconClass &&
              html` <i class=${iconClass} aria-hidden="true"></i> `}
              <span>${label}</span>
            </a>
          `,
        )}
      </div>
    `;
  }
}

export { DesktopNavigationFooter };
